
import CircleCheck from '../../../assets/svg/CircleCheck';
import SurveyModal from '../../../components/SurveyModal/SurveyModal';
import { ApplicationStatus } from '../../../domain/types';
import useComponentTracker from '../../../hooks/useComponentTracker';
import useTranslation from '../../../hooks/useTranslation';
import StatusPage from '../StatusPage';

const StatusCompletePage = () => {
    useComponentTracker('StatusCompletePage', ApplicationStatus.complete);
    const translate = useTranslation();

    return (
        <>
            <StatusPage
                icon={<CircleCheck />}
                title={translate(`page.status-complete.title`)}
                body={translate(`page.status-complete.description`)}
            />
            <SurveyModal
                label={translate('dialog.survey.label')}
                dialogTitle={translate('dialog.survey.title')}
                dialogSubtitle={translate('dialog.survey.subtitle')}
                dialogPlaceholder={translate('dialog.survey.placeholder')}
                dialogCheckboxLabel={translate('dialog.survey.checkbox-label')}
                dialogButton={translate('dialog.survey.button')}
            />
        </>
    );
};

export default StatusCompletePage;
